import React from 'react';

import { EVENT_ITEM_PLAN } from '../../../../constants/event-items';

export const EVENT_ITEM_FEATURE = {
  SMART_SLIDESHOW: 'SMART_SLIDESHOW',
  VIDEO_GUEST_BOOK: 'VIDEO_GUEST_BOOK',
  MEMORIES_SMART_SLIDESHOW: 'MEMORIES_SMART_SLIDESHOW',
  FACIAL_REC_DELIVERY: 'FACIAL_REC_DELIVERY',
  PERSONALIZED_SMS: 'PERSONALIZED_SMS',
  BULK_GUEST_AND_INVITES: 'BULK_GUEST_AND_INVITES',
  WALDO_BRANDING: 'WALDO_BRANDING',
  CONTRIBUTORS: 'CONTRIBUTORS',
  THANK_YOU_CARDS: 'THANK_YOU_CARDS',
  APPS: 'APPS',
  STORAGE: 'STORAGE',
};

export const EVENT_ITEM_FEATURE_LABELS = {
  [EVENT_ITEM_FEATURE.SMART_SLIDESHOW]: 'Live Smart Slideshow',
  [EVENT_ITEM_FEATURE.VIDEO_GUEST_BOOK]: 'Video Guestbook',
  [EVENT_ITEM_FEATURE.MEMORIES_SMART_SLIDESHOW]: 'Memories Slideshow',
  [EVENT_ITEM_FEATURE.FACIAL_REC_DELIVERY]:
    'Automated photo delivery to guests (w/ facial rec)',
  [EVENT_ITEM_FEATURE.PERSONALIZED_SMS]:
    'Personalized SMS code for easy guests joining',
  [EVENT_ITEM_FEATURE.BULK_GUEST_AND_INVITES]:
    'Bulk guest list import & invites',
  [EVENT_ITEM_FEATURE.WALDO_BRANDING]: 'Waldo branding (signage & photos)',
  [EVENT_ITEM_FEATURE.CONTRIBUTORS]: 'Contributor photo moderation',
  [EVENT_ITEM_FEATURE.THANK_YOU_CARDS]: 'Free Thank You cards',
  [EVENT_ITEM_FEATURE.APPS]: 'Web, iOS, & Android access',
  [EVENT_ITEM_FEATURE.STORAGE]: 'Storage',
};

export const EVENT_ITEM_FEATURE_META = {
  [EVENT_ITEM_PLAN.FREE]: {
    [EVENT_ITEM_FEATURE.SMART_SLIDESHOW]: false,
    [EVENT_ITEM_FEATURE.VIDEO_GUEST_BOOK]: false,
    [EVENT_ITEM_FEATURE.MEMORIES_SMART_SLIDESHOW]: false,
    [EVENT_ITEM_FEATURE.FACIAL_REC_DELIVERY]: false,
    [EVENT_ITEM_FEATURE.PERSONALIZED_SMS]: false,
    [EVENT_ITEM_FEATURE.BULK_GUEST_AND_INVITES]: false,
    [EVENT_ITEM_FEATURE.WALDO_BRANDING]: 'Waldo-branded',
    [EVENT_ITEM_FEATURE.CONTRIBUTORS]: false,
    [EVENT_ITEM_FEATURE.THANK_YOU_CARDS]: '-',
    [EVENT_ITEM_FEATURE.APPS]: true,
    [EVENT_ITEM_FEATURE.STORAGE]: '10GB / 1 year',
  },
  [EVENT_ITEM_PLAN.BASIC]: {
    [EVENT_ITEM_FEATURE.SMART_SLIDESHOW]: false,
    [EVENT_ITEM_FEATURE.VIDEO_GUEST_BOOK]: false,
    [EVENT_ITEM_FEATURE.MEMORIES_SMART_SLIDESHOW]: false,
    [EVENT_ITEM_FEATURE.FACIAL_REC_DELIVERY]: true,
    [EVENT_ITEM_FEATURE.PERSONALIZED_SMS]: true,
    [EVENT_ITEM_FEATURE.BULK_GUEST_AND_INVITES]: true,
    [EVENT_ITEM_FEATURE.WALDO_BRANDING]: 'No-branding',
    [EVENT_ITEM_FEATURE.CONTRIBUTORS]: true,
    [EVENT_ITEM_FEATURE.THANK_YOU_CARDS]: '25',
    [EVENT_ITEM_FEATURE.APPS]: true,
    [EVENT_ITEM_FEATURE.STORAGE]: '50GB / 1 year',
  },
  [EVENT_ITEM_PLAN.PREMIUM]: {
    [EVENT_ITEM_FEATURE.SMART_SLIDESHOW]: true,
    [EVENT_ITEM_FEATURE.VIDEO_GUEST_BOOK]: true,
    [EVENT_ITEM_FEATURE.MEMORIES_SMART_SLIDESHOW]: true,
    [EVENT_ITEM_FEATURE.FACIAL_REC_DELIVERY]: true,
    [EVENT_ITEM_FEATURE.PERSONALIZED_SMS]: true,
    [EVENT_ITEM_FEATURE.BULK_GUEST_AND_INVITES]: true,
    [EVENT_ITEM_FEATURE.WALDO_BRANDING]: 'No-branding',
    [EVENT_ITEM_FEATURE.CONTRIBUTORS]: true,
    [EVENT_ITEM_FEATURE.THANK_YOU_CARDS]: '50',
    [EVENT_ITEM_FEATURE.APPS]: true,
    [EVENT_ITEM_FEATURE.STORAGE]: '100GB / 2 years',
  },
};

export const features = {
  [EVENT_ITEM_PLAN.FREE]: [
    'iOS, Android, and web-accessible',
    'Unlimited albums & contributors',
    '10GB storage for a year',
  ],
  [EVENT_ITEM_PLAN.BASIC]: [
    <>
      Everything in{' '}
      <strong className="text-extra-bold text-uppercase">Basic</strong>{' '}
      and&hellip;
    </>,
    'SMS photo delivery to guests',
    'Personalized SMS join code',
    'Photo filtering & hashtag',
    'Photo moderation',
    'Watermark removal',
    '25 Thank You cards',
    '50GB storage (1 year)',
  ],
  [EVENT_ITEM_PLAN.PREMIUM]: [
    <>
      Everything in{' '}
      <strong className="text-extra-bold text-uppercase">Gold</strong>{' '}
      and&hellip;:
    </>,
    'Live slideshows',
    'Video Guestbook',
    '50 free Thank You cards (total)',
    '100GB storage for two years',
  ],
};

export const featureList = {};
